import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UiState {
  siderCollapsed: boolean;
}

const initialState: UiState = {
  siderCollapsed: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    siderToggled: (state, action: PayloadAction<boolean | undefined>) => {
      state.siderCollapsed = action.payload ?? !state.siderCollapsed;
    },
  },
});

export const { siderToggled } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
